import React from 'react';
import { useHistory } from 'react-router-dom';
import App from '@app';
import { Body, PageHeader, AddButton } from '@components';
import TableFolgas from './TableFolgas';

export default function Folgas() {
  const history = useHistory();

  return (
    <App>
      <Body>
        <PageHeader
          title="Folgas"
          extra={[
            <AddButton
              key="1"
              type="primary"
              tooltipTitle="Adicionar Folga"
              style={{ marginBottom: 10 + 'px', borderRadius: 5 + 'px' }}
              onClick={() => history.push('/conectores/folga/-1')}
            />,
          ]}
        >
          <TableFolgas />
        </PageHeader>
      </Body>
    </App>
  );
}
